import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { EditSalesPage } from "@/modules/user";
import { requireAuthAndPermission } from "@/utils";

export const Route = createFileRoute("/users/sales/$salesId")({
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Edit Sales"
        description="Edit sales team member details."
      />
      <EditSalesPage />
    </>
  )
});
